import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

const PhoneMask = forwardRef((props, ref) => {
  const { onChange, ...rest } = props;

  return (
    <IMaskInput
      {...rest}
      mask="000-000-0000"
      inputRef={ref}
      onAccept={(value) => onChange({ target: { value } })}
      overwrite
    />
  );
});

export default PhoneMask;
